import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNormalizedDeviationStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';
import ProductCategories from '../ProductCategories';
import RecommendedSellSlider from '../RecommendedSellSlider';
import ExpandSalesSlider from '../ExpandSalesSlider';
import StudioHeading from '../../StudioHeading';
import { STUDIO_DEVIATIONS_STREAM } from '../../../../constants';

import s from './ProductsLobbyPageContent.scss';

interface Props {}

const ProductsLobbyPageContent: FC<Props> = () => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { streamId, streamConfig, streamThrottle } = STUDIO_DEVIATIONS_STREAM;
  const { items: deviations } = useNormalizedDeviationStream(
    streamId,
    streamThrottle,
    streamConfig
  );

  if (isMobile) {
    return (
      <ScrollableContent>
        <div className={s['mobile-heading']}>
          <StudioHeading>
            {t('studio.header.tabs.products_lobby')}
          </StudioHeading>
        </div>
        <ProductCategories />
        <div className={s['content']}>
          <RecommendedSellSlider deviations={deviations} />
          <ExpandSalesSlider />
        </div>
      </ScrollableContent>
    );
  }
  return (
    <div className={s['root']}>
      <ProductCategories />
      <RecommendedSellSlider deviations={deviations} />
      <ExpandSalesSlider />
    </div>
  );
};
ProductsLobbyPageContent.displayName = 'ProductsLobbyPageContent';

export default ProductsLobbyPageContent;
